import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Small reusable support-code hint for patient-facing backend/access errors.
 *
 * @param {{
 *   supportCode?: string | null,
 *   technicalCode?: string | null,
 *   className?: string
 * }} props - Render options.
 * @returns {JSX.Element | null} Support hint or null when no code is available.
 */
export default function RegionalSupportCodeNotice({
  supportCode,
  technicalCode = null,
  className = "",
}) {
  const { t } = useTranslation();

  if (!supportCode) {
    return null;
  }

  return (
    <div className={`mt-2 text-xs text-greyscale-3 ${className}`.trim()}>
      <p>{t("regionalBackend.support.code", { code: supportCode })}</p>
      <p>{t("regionalBackend.support.help")}</p>
      {process.env.NODE_ENV === "development" && technicalCode ? (
        <p>{t("regionalBackend.support.technicalCode", { code: technicalCode })}</p>
      ) : null}
    </div>
  );
}
